import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Input, Row, Col } from 'reactstrap';
import BaseComponent from './BaseComponent';
import { emailRegex } from 'common/utils/data_validations';
import { handleKeyDown } from 'helpers/quote_funnel_helper';

/**
 * EmailComponent is a reusable React component that renders a form component field with an associated label and tooltip.
 * 
 * @param {Object} props - The props for the EmailComponent.
 * @param {Object} props.label - An object containing properties related to the label.
 * @param {string} props.label.name - The name of the label.
 * @param {string} props.label.tooltip - The tooltip message for the label.
 * @param {Object} props.component - An object containing properties related to the component field.
 * @param {string} props.component.id - The ID of the component field.
 * @param {string} props.component.name - The name of the component field.
 * @param {string} props.component.type - The type of the component field (default is 'text').
 * @param {Object} props.validation - An object containing form validation properties.
 * @param {Function} props.validation.handleChange - The function to handle component changes.
 * @param {Function} props.validation.handleBlur - The function to handle component blur.
 * @param {Object} props.validation.values - An object containing form values.
 * @param {Object} props.validation.touched - An object indicating whether fields have been touched.
 * @param {Object} props.validation.errors - An object containing validation errors.
 * 
 * @returns {JSX.Element} - A React component that renders an component field with label and tooltip.
 */
const EmailComponent = ({ index, question, onChangeEvent }) => {
    const [isValidEmail, setIsValidEmail] = useState(true);
    const handleChange = async (e) => {
        const inputValue = e.target.value;
        onChangeEvent(inputValue);
        const isEmailValid = (emailRegex).test(inputValue);
        setIsValidEmail(isEmailValid);
    };

    return (
        <BaseComponent question={question}>
            <Row key={index}>
                <Col md={12} className='mb-2'>
                    <Input
                        id={question?.id || ''}
                        name={question?.field_name || ''}
                        type={question?.question_type || 'text'}
                        className={`quote-funnel-form-control`}
                        placeholder={question?.placeholder || ''}
                        value={question?.value || ''}
                        autoFocus={true}
                        onKeyDown={handleKeyDown}
                        onChange={question?.question_type !== 'email' ? (e) => onChangeEvent(e.target.value) : handleChange}
                    />
                    {!isValidEmail && (
                        <div className="invalid-feedback">Invalid email address</div>
                    )}
                </Col>
            </Row>
        </BaseComponent>
    );
}

EmailComponent.propTypes = {
    label: PropTypes.object,
    component: PropTypes.object,
    validation: PropTypes.object,
};

export default EmailComponent;
